var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('el-tooltip',{attrs:{"popper-class":_vm.big ? 'black-pop big' : 'black-pop',"effect":"dark","content":_vm.text,"placement":_vm.place,"disabled":_vm.disabled}},[_vm._t("temp")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }